import { CONTENT_TYPES } from 'core/variables/constant';
import { noShowContentInSmartLink } from 'core/utils/lessonItems';

export function getCurrentReferenceMaterial(currentTest) {
  if (currentTest?.smart_link) {
    const contentGuid = currentTest.smart_link.content?.guid || currentTest.smart_link.content_guid || currentTest.smart_link.cms_content_guid;
    if (!contentGuid) return null;
    return {
      guid: contentGuid,
      name: currentTest.smart_link?.name ? currentTest.smart_link?.name : currentTest.smart_link.content?.name,
      content_name: currentTest.smart_link.content?.name || currentTest.smart_link?.name,
      content_guid: contentGuid,
      content_type_guid: currentTest.smart_link.content?.type || currentTest.smart_link.content?.type_guid || currentTest.smart_link.content_type_guid,
      lesson_item_guid: currentTest.smart_link.lesson_item_guid,
      lesson_guid: currentTest.smart_link.lesson_guid,
      content_url: currentTest.smart_link.content?.url,
    };
  }
  return null;
}

export const hasSmartLink = (type) => {
  return [CONTENT_TYPES.TEST, CONTENT_TYPES.QUESTION].includes(type);
};

export const isMintPageReference = (type) => [CONTENT_TYPES.MINT_PAGE, CONTENT_TYPES.MINT_PAGE_DUAL].includes(type);

export function buildSmartLink(material) {
  if (!material) return null;
  return {
    content_guid: material.content_guid || material.content?.guid || material.cms_content_guid || material.guid,
    name: material.name || material.content?.name,
    ...(material.lesson_item_guid && { lesson_item_guid: material.lesson_item_guid }),
  };
}

export function onClickOpenReferenceMaterial(referenceMaterial, courseGuid, onUnavailable = () => {}) {
  if (!referenceMaterial) return;
  if (isMintPageReference(referenceMaterial.content_type_guid)) {
    if (!courseGuid || !referenceMaterial.lesson_guid || !referenceMaterial.lesson_item_guid) {
      onUnavailable();
      return;
    }
    window.open(`/course/${courseGuid}/lesson/${referenceMaterial.lesson_guid}?lessonItemGuid=${referenceMaterial.lesson_item_guid}`, '_blank');
    return;
  }
  if (referenceMaterial.content_type_guid === CONTENT_TYPES.XAPI) {
    window.open(`/viewerfull-v1/${referenceMaterial.content_guid}`, '_blank');
  } else {
    window.open(`/viewer/${referenceMaterial.content_guid}`, '_blank');
  }
}

/**
 * Aplana los items de una lección. Los items pueden llegar de distintas formas:
 * - como materiales sueltos en el primer nivel (sin sección),
 * - agrupados dentro de una o varias secciones (con items anidados),
 * - o una mezcla de ambos (algunos sueltos y otros dentro de secciones).
 * Recorre recursivamente los items anidados para devolver siempre la lista plana
 * de materiales, independientemente de si están o no dentro de una sección.
 * @param {Array} items - Items de la lección (secciones y/o materiales)
 * @returns {Array} - Lista plana de materiales
 */
function flattenLessonItems(items = []) {
  return items.reduce((resources, item) => {
    if (item?.items?.length > 0) {
      return resources.concat(flattenLessonItems(item.items));
    }
    resources.push(item);
    return resources;
  }, []);
}

export function filterNonEvaluableContents(items = []) {
  const resources = flattenLessonItems(items);
  const nonEvaluableContents = resources.filter(
    (resource) => resource.content_type_guid && !noShowContentInSmartLink(resource.content_type_guid) && !resource?.content_is_teacher_only
  );

  return nonEvaluableContents;
}
